import UAI from "../UAI"
import UAIStats from "./UAIStats"

class UAIStatsCohorte {
  Id = 0
  Matriculados = 0
  Postulantes = 0
  Aceptados = 0
  Equivalentes = 0
  Borrados = 0
  Raw = []
  PorEntrevistar = 0
  SinPagoFeePostulacion = 0
  Retirados = 0
  RetiradosPostMatricula = 0
  RetiradosSinMatricula = 0
  VentasCLP = 0
  VentasCLF = 0
  VentasUSD = 0
  esBenchmark = false
  Fecha = null
  SinDatos = false
  Interesados = 0
  InteresadosOrganicos = 0
  InteresadosCampañas = 0
  Visitantes = 0
  URLVisitantes = null
  MetaMatriculados = 0
  MetaPostulantes = 0
  MetaEquivalentes = 0
  MetasMensuales = []
  MetaTotalMatriculados = 0
  MetaTotalPostulantes = 0
  MetaTotalEquivalentes = 0
  Coordinadora = null
  constructor(
    _cohorte,
    _stats,
    _noSumarPendienteFirma = false,
    _restarBorrados = false,
    _fecha = null
  ) {
    if (_fecha !== null && _fecha !== undefined) {
      this.Fecha = _fecha
    }
    if (_cohorte === null || _cohorte === undefined) {
      this.SinDatos = true
      return
    }
    if (_cohorte.parsed_datos_salesforce) {
      this.Interesados = _cohorte.parsed_datos_salesforce.Oportunidades
      this.InteresadosOrganicos = _cohorte.parsed_datos_salesforce.Organicos
      this.InteresadosCampañas = this.Interesados - this.InteresadosOrganicos
    }
    if (
      _cohorte.parsed_google_analytics_data &&
      Array.isArray(_cohorte.parsed_google_analytics_data) &&
      _cohorte.parsed_google_analytics_data.length > 0
    ) {
      let gdata = _cohorte.parsed_google_analytics_data.find((c) => {
        return (
          c["columnHeader"]["metricHeader"]["metricHeaderEntries"] &&
          c["columnHeader"]["metricHeader"]["metricHeaderEntries"][0] &&
          c["columnHeader"]["metricHeader"]["metricHeaderEntries"][0][
            "name"
          ] === "ga:users" &&
          c["columnHeader"]["metricHeader"]["metricHeaderEntries"][0][
            "type"
          ] === "INTEGER"
        )
      })
      if (
        gdata &&
        gdata.data &&
        gdata.data.rows &&
        gdata.data.rows[0] &&
        gdata.data.rows[0].metrics &&
        gdata.data.rows[0].metrics[0] &&
        gdata.data.rows[0].metrics[0].values &&
        gdata.data.rows[0].metrics[0].values[0]
      ) {
        this.Visitantes = parseInt(gdata.data.rows[0].metrics[0].values[0])
      }
    }
    if (
      _cohorte.parsed_metas_mensuales &&
      _cohorte.parsed_metas_mensuales.metas
    ) {
      this.MetasMensuales = _cohorte.parsed_metas_mensuales.metas
      let metaActual = UAI.obtieneMetaActualCohorte(_cohorte)
      let metaTotal = UAI.obtieneMetaTotalCohorte(_cohorte)
      if (metaActual) {
        this.MetaMatriculados = metaActual.Matriculados
        this.MetaPostulantes = metaActual.Postulantes
        this.MetaEquivalentes = metaActual.Equivalentes
      }
      if (metaTotal) {
        this.MetaTotalMatriculados = metaTotal.Matriculados
        this.MetaTotalPostulantes = metaTotal.Postulantes
        this.MetaTotalEquivalentes = metaTotal.Equivalentes
      }
    }
    if (
      _stats === null ||
      _stats === undefined ||
      _stats.Respuesta === "Sin Datos"
    ) {
      this.SinDatos = true
      return
    }
    this.Id = _stats.CohorteId
    if (_noSumarPendienteFirma) {
      this.Matriculados = _stats.Matriculados
    } else {
      this.Matriculados = _stats.Matriculados + _stats.PendienteFirma
    }
    this.Coordinadora = _cohorte.coordinador_academico
    this.Aceptados = _stats.Aceptados + _stats.AceptadoAcademicamente
    if (_restarBorrados) {
      this.Postulantes =
        _stats.Postulantes -
        _stats.SinPagoFeePostulacion -
        _stats.PostulacionesEliminadas
    } else {
      this.Postulantes = _stats.Postulantes - _stats.SinPagoFeePostulacion
    }

    this.URLVisitantes = _cohorte.nombrecorto
    this.Retirados = _stats.Retirados
    this.RetiradosPostMatricula = _stats.RetiradoPostMatricula
    this.RetiradosSinMatricula = _stats.RetiradoSinMatricula
    this.Equivalentes = _stats.ContratosVigentesEquivalentes
    this.Borrados = _stats.PostulacionesEliminadas
    this.PorEntrevistar = _stats.PorEntrevistar
    this.SinPagoFeePostulacion = _stats.SinPagoFeePostulacion
    this.Fecha = new Date(Date.parse(_stats.Fecha))
    this.Raw.push(_stats)
    if (
      _stats !== null &&
      _stats.ContratosVigentesEquivalentes !== null &&
      _stats.ContratosVigentesEquivalentes > 0
    ) {
      // En UF
      if (_cohorte.id_tipo_moneda_precio === 3) {
        this.VentasCLP =
          _cohorte.precio *
          UAIStats.valorUF *
          _stats.ContratosVigentesEquivalentes
        this.VentasCLF = _cohorte.precio * _stats.ContratosVigentesEquivalentes
        this.VentasUSD =
          ((_cohorte.precio * UAIStats.valorUF) / UAIStats.valorUSD) *
          _stats.ContratosVigentesEquivalentes
      } else if (_cohorte.id_tipo_moneda_precio === 1) {
        this.VentasCLP = _cohorte.precio * _stats.ContratosVigentesEquivalentes
        this.VentasCLF =
          (_cohorte.precio / UAIStats.valorUF) *
          _stats.ContratosVigentesEquivalentes
        this.VentasUSD =
          ((_cohorte.precio * UAIStats.valorUSD) / UAIStats.valorUF) *
          _stats.ContratosVigentesEquivalentes
      } else {
        this.VentasCLP =
          _cohorte.precio *
          UAIStats.valorUSD *
          _stats.ContratosVigentesEquivalentes
        this.VentasCLF =
          ((_cohorte.precio * UAIStats.valorUSD) / UAIStats.valorUF) *
          _stats.ContratosVigentesEquivalentes
        this.VentasUSD = _cohorte.precio * _stats.ContratosVigentesEquivalentes
      }
    }
  }
  static sumaStats(StatsA, StatsB, nombrescortos = undefined) {
    let newStat = new UAIStatsCohorte(null)
    newStat.Postulantes = StatsA.Postulantes + StatsB.Postulantes
    newStat.Matriculados = StatsA.Matriculados + StatsB.Matriculados
    newStat.Aceptados = StatsA.Aceptados + StatsB.Aceptados
    newStat.Equivalentes = StatsA.Equivalentes + StatsB.Equivalentes
    newStat.MetaPostulantes = StatsA.MetaPostulantes + StatsB.MetaPostulantes
    newStat.MetaMatriculados = StatsA.MetaMatriculados + StatsB.MetaMatriculados
    newStat.MetaEquivalentes = StatsA.MetaEquivalentes + StatsB.MetaEquivalentes
    newStat.MetaTotalPostulantes =
      StatsA.MetaTotalPostulantes + StatsB.MetaTotalPostulantes
    newStat.MetaTotalMatriculados =
      StatsA.MetaTotalMatriculados + StatsB.MetaTotalMatriculados
    newStat.MetaTotalEquivalentes =
      StatsA.MetaTotalEquivalentes + StatsB.MetaTotalEquivalentes
    newStat.PorEntrevistar = StatsA.PorEntrevistar + StatsB.PorEntrevistar
    newStat.Retirados = StatsA.Retirados + StatsB.Retirados
    newStat.RetiradosPostMatricula =
      StatsA.RetiradosPostMatricula + StatsB.RetiradosPostMatricula
    newStat.RetiradosSinMatricula =
      StatsA.RetiradosSinMatricula + StatsB.RetiradosSinMatricula
    newStat.esBenchmark = StatsA.esBenchmark || StatsB.esBenchmark
    newStat.Fecha = StatsB.Fecha !== null ? StatsB.Fecha : StatsA.Fecha
    newStat.Raw = StatsA.Raw.concat(StatsB.Raw)
    newStat.VentasCLP = StatsA.VentasCLP + StatsB.VentasCLP
    newStat.VentasCLF = StatsA.VentasCLF + StatsB.VentasCLF
    newStat.VentasUSD = StatsA.VentasUSD + StatsB.VentasUSD
    newStat.Interesados = StatsA.Interesados + StatsB.Interesados
    newStat.InteresadosOrganicos =
      StatsA.InteresadosOrganicos + StatsB.InteresadosOrganicos
    newStat.InteresadosCampañas =
      StatsA.InteresadosCampañas + StatsB.InteresadosCampañas
    newStat.URLVisitantes = StatsB.URLVisitantes
    newStat.Visitantes = StatsA.Visitantes
    if (
      !nombrescortos ||
      StatsB.URLVisitantes === null ||
      (StatsB.URLVisitantes &&
        nombrescortos.indexOf(StatsB.URLVisitantes) < 0 &&
        !StatsB.URLVisitantes.endsWith("-cont"))
    ) {
      newStat.Visitantes = StatsA.Visitantes + StatsB.Visitantes
    }
    let newMetas = []
    UAI.meses.forEach((mes) => {
      StatsA.MetasMensuales = StatsA.MetasMensuales || []
      let previous = StatsA.MetasMensuales.find((m) => {
        return m.Mes === mes
      })
      StatsB.MetasMensuales = StatsB.MetasMensuales || []
      let current = StatsB.MetasMensuales.find((m) => {
        return m.Mes === mes
      })
      if (!previous && !current) {
        return
      }
      if (!previous) {
        newMetas.push(current)
        return
      }
      if (!current) {
        newMetas.push(previous)
        return
      }
      newMetas.push({
        Mes: mes,
        Postulantes: previous.Postulantes + current.Postulantes,
        Matriculados: previous.Matriculados + current.Matriculados,
        Equivalentes: previous.Equivalentes + current.Equivalentes,
      })
    })
    newStat.MetasMensuales = newMetas
    return newStat
  }
}

export default UAIStatsCohorte
